export const getLinesFromHighlight = (
  activeLines: Array<string | number>,
): number[] => {
  if (activeLines.length) {
    return activeLines.reduce((acc: number[], line) => {
      if (typeof line === 'number') {
        return [...acc, line];
      }
      if (typeof line === 'string') {
        const lines = line.split('-');
        if (lines.length === 1) {
          return [...acc, parseInt(line, 10)];
        }
        if (lines.length === 2) {
          // only return one line if both ends of the range are equal
          if (lines[0] === lines[1]) {
            return [...acc, parseInt(lines[0], 10)];
          }

          const start = parseInt(lines[0], 10);
          // add 1 to include the start and end line
          const length = parseInt(lines[1], 10) - start + 1;
          return [...acc, ...Array.from({ length }, (v, i) => i + start)];
        }
      }

      return acc;
    }, []);
  }

  return [];
};
